import { render, staticRenderFns } from "./ReferralPayment.vue?vue&type=template&id=29d3f62e&scoped=true&"
import script from "./ReferralPayment.vue?vue&type=script&lang=ts&"
export * from "./ReferralPayment.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralPayment.vue?vue&type=style&index=0&id=29d3f62e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d3f62e",
  null
  
)

export default component.exports